module.exports = __webpack_public_path__ + "img/top2.95cc812b.jpg";